import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import Guid from "./../factories/guid";

class Shiftbook extends BaseViewModel {

    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SelectedShiftbookType.subscribe((newValue) => {
            let oldValue = this.ShiftbookTypeKey();
            if (newValue !== null) {
                this.ShiftbookTypeId(newValue.ShiftbookTypeId);
                this.ShiftbookTypeKey(newValue.Key);
                if (this.IsNew()) {
                    if (this.ShiftbookTypeKey() === "WorkItemTaskbook") {
                        this.WorkItemCollectionId(Guid());
                    }
                    else {
                        this.WorkItemCollectionId(null);
                    }
                }
               
            }
            else {
                this.ShiftbookTypeKey(null);
            }
            this.loadTabs(oldValue);
        });
        this.ApprovalRequired.subscribe((newValue) => {
            if (newValue == false) {
                this.ApprovalIsMandatory(false);
            }
        });
        this.SelectedIcon.subscribe((newValue) => {
            if (newValue !== null) {
                this.CssClass(newValue.CssClass);
            }
            else {
                this.CssClass(null);
            }
        });
    }
    IsNew: KnockoutObservable<boolean> = ko.observable(false);
    TabAssignmentTab: TabPage;
    PersonTab: TabPage;
    ChecklistTab: TabPage;
    UniversalFieldTab: TabPage;
    TransferDefinitionTab: TabPage;
    WorkplaceTab: TabPage;
    ShiftbookChecklistTab: TabPage;
    ShiftbookRecipientTab: TabPage;
    RoleTab: Factories.TabPage;
    ShiftbookShiftPlanModelTab: Factories.TabPage;

    ShiftbookId: KnockoutObservable<string> = ko.observable();
    Name: KnockoutObservable<string> = ko.observable();
    Description: KnockoutObservable<string> = ko.observable();
    ShiftbookTypeKey: KnockoutObservable<string> = ko.observable();
    ShiftbookTypeId: KnockoutObservable<string> = ko.observable();
    SelectedShiftbookType = ko.observable<any>();
    AreaId: KnockoutObservable<string> = ko.observable();
    AreaName: KnockoutObservable<string> = ko.observable();
    Categories: KnockoutObservableArray<{
        CategoryFullName: string;
        CategoryStructureId: string;
    }> = ko.observableArray();
    CategoryStructureId: KnockoutObservable<string> = ko.observable();
    InfoLevelId: KnockoutObservable<string> = ko.observable();
    InfoLevelName: KnockoutObservable<string> = ko.observable();
    ApprovalRequired: KnockoutObservable<boolean> = ko.observable();
    ApprovalIsMandatory: KnockoutObservable<boolean> = ko.observable();
    ListReportLayoutAvailableReportId: KnockoutObservable<string> = ko.observable();
    ListReportLayoutAvailableReportName: KnockoutObservable<string> = ko.observable();
    DetailReportLayoutAvailableReportId: KnockoutObservable<string> = ko.observable();
    DetailReportLayoutAvailableReportName: KnockoutObservable<string> = ko.observable();
    ListReportLayoutName: KnockoutObservable<string> = ko.observable();
    DetailReportLayoutName: KnockoutObservable<string> = ko.observable();
    ListReportLayoutId: KnockoutObservable<string> = ko.observable();
    DetailReportLayoutId: KnockoutObservable<string> = ko.observable();
    IconId: KnockoutObservable<string> = ko.observable();
    CssClass: KnockoutObservable<string> = ko.observable();
    IconName: KnockoutObservable<string> = ko.observable();
    SelectedIcon = ko.observable<any>();
    DefaultCssClass: KnockoutObservable<string> = ko.observable();
    InfoStateId: KnockoutObservable<string> = ko.observable();
    InfoStateName: KnockoutObservable<string> = ko.observable();
    AllowConfidentialEntries: KnockoutObservable<boolean> = ko.observable();
    ShiftReportDefaultVersion: KnockoutObservable<string> = ko.observable();
    ShiftbookTypeName: KnockoutObservable<string> = ko.observable();
    DeleteNextReports: KnockoutObservable<boolean> = ko.observable(false);
    /**
     * Id of WorkItemCollection
     */
    WorkItemCollectionId: KnockoutObservable<string> = ko.observable();
    WorkItemCollectionKey: KnockoutObservable<string> = ko.observable();

    IsMandatoryInfoText: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryArea: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryCategory: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryAreaEquipment: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryDevice3: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryDevice4: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryPriority: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryInfoState: KnockoutObservable<boolean> = ko.observable(false);
    IsMandatoryShiftLossInfo: KnockoutObservable<boolean> = ko.observable(false);
    IsAutomaticReadWorkflowEnabled: KnockoutObservable<boolean> = ko.observable(false);

    ShiftBookTypeSearcher: Bindings.baoSearcher = {
        SearchType: "ShiftbookType",
        ObjectId: this.ShiftbookTypeId,
        ObjectValue: "Name",
        SelectedItem: this.SelectedShiftbookType,
        AutoComplete: true,
        AutoSearch: true,
        Enabled: this.IsNew
    };
    AreaSearcher: Bindings.baoSearcher = {
        SearchType: "Area",
        ObjectId: this.AreaId,
        ObjectValue: "ShortName",
        AutoComplete: true,
        AutoSearch: true
    };
    InfoLevelSearcher: Bindings.baoSearcher = {
        SearchType: "Priority",
        ObjectId: this.InfoLevelId,
        ObjectValue: "InfoLevelText",
        AutoComplete: true,
        AutoSearch: true
    };
    ReportLayoutSearcherList: Bindings.baoSearcher = {
        SearchType: "ReportLayout",
        ObjectId: this.ListReportLayoutId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true
    };
    ReportLayoutSearcherDetail: Bindings.baoSearcher = {
        SearchType: "ReportLayout",
        ObjectId: this.DetailReportLayoutId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true
    };
    ReportLayoutAvailableReportSearcherDetail: Bindings.baoSearcher = {
        SearchType: "ReportLayoutAvailableReport",
        ObjectId: this.DetailReportLayoutAvailableReportId,
        ObjectValue: "ReportLayoutName",
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ReportLayoutId: this.DetailReportLayoutId }
    };
    ReportLayoutAvailableReportSearcherList: Bindings.baoSearcher = {
        SearchType: "ReportLayoutAvailableReport",
        ObjectId: this.ListReportLayoutAvailableReportId,
        ObjectValue: "ReportLayoutName",
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ReportLayoutId: this.ListReportLayoutId }
    };
    IconSearcher: Bindings.baoSearcher = {
        SearchType: "Icon",
        ObjectId: this.IconId,
        ObjectValue: "Name",
        SelectedItem: this.SelectedIcon,
        AutoComplete: true,
        AutoSearch: true
    };
    InfoStateSearcher: Bindings.baoSearcher = {
        SearchType: "State",
        ObjectId: this.InfoStateId,
        ObjectValue: "StateText",
        AutoComplete: true,
        AutoSearch: true
    };
    InitUrl() {
        return "Shiftbook/Init";
    }
    init() {
        return $.when(super.init(), super.InitTabController(), this.loadCategories())
            .then(() => this.loadTabs(null))
            .then(() => this.getIconName())
            .then(() => this.DefaultCssClass(this.CssClass()));
    }
    CompleteCheck() {
        let isEachMandatoryFieldComplete = true;
        let isMandatoryShiftbookTabComplete = true;
        let shiftBookTypeKey = this.ShiftbookTypeKey();
        //Regular checks
        if (Bao.Utils.String.IsNullOrEmpty(this.Name())
            || Bao.Utils.String.IsNullOrEmpty(this.Description())
            || (Bao.Utils.String.IsNullOrEmpty(this.ShiftbookTypeId()) && this.IsNew())) {
                isEachMandatoryFieldComplete = false;
        }        
        //Has at least one Shiftbook Tab check - dialog is rendered by ShiftbookShiftPlanModel/Validate endpoint 
        else if (shiftBookTypeKey === "ShiftBook" && this.TabAssignmentTab.ViewModel().TotalRows() === 0) {
            isMandatoryShiftbookTabComplete = false;
        }
        else if (shiftBookTypeKey === "WorkItemTaskbook" && Bao.Utils.String.IsNullOrEmpty(this.WorkItemCollectionKey())) {
            isEachMandatoryFieldComplete = false;
        }
        if (!isEachMandatoryFieldComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");        
        }
        return isEachMandatoryFieldComplete && isMandatoryShiftbookTabComplete;
    }
    Save() {
        this.TabPage.IsLoading(true);
        return super.Save()
            .then(() => this.DeleteExistsNextReports())
            .then(() => this.ChangeIconOnQuickStartModule())
            .always(() => this.TabPage.IsLoading(false));
    }
    private loadCategories = () => {
        return Bao.post("Shiftbook/GetCategories")
            .done(categories => {
                this.Categories(categories);
            });
    };
    private getIconName = () => {
        return Bao.post("Icon/GetIconName", JSON.stringify({ cssClass: this.CssClass() }))
            .then(result => this.IconName(result.IconName));
    };
    private loadTabs = (oldValueType: string) => {
        if (this.ShiftbookTypeKey() === oldValueType) {
            return;
        }
        this.TabController.DestroyAll();
        this.RoleTab = new TabPage('ShiftbookRole');
        this.RoleTab.IsClosable(false);
        this.RoleTab.Url("ShiftbookRole");
        this.RoleTab.AutoSelect = true;
        this.TabController.AddTab(this.RoleTab);

        if (this.ShiftbookTypeKey() === "ShiftBook") {
            this.TabAssignmentTab = new TabPage('ShiftbookTabAssignment');
            this.TabAssignmentTab.IsClosable(false);
            this.TabAssignmentTab.Url("ShiftbookTabAssignment");
            this.TabAssignmentTab.AutoSelect = false;
            this.TabController.AddTab(this.TabAssignmentTab);

            this.PersonTab = new TabPage('ShiftbookPerson');
            this.PersonTab.IsClosable(false);
            this.PersonTab.Url("ShiftbookPerson");
            this.PersonTab.AutoSelect = false;
            this.TabController.AddTab(this.PersonTab);

            this.WorkplaceTab = new TabPage('ShiftbookWorkplace');
            this.WorkplaceTab.IsClosable(false);
            this.WorkplaceTab.Url("ShiftbookWorkplace");
            this.WorkplaceTab.AutoSelect = false;
            this.TabController.AddTab(this.WorkplaceTab);

            this.UniversalFieldTab = new TabPage();
            this.UniversalFieldTab.IsClosable(false);
            this.UniversalFieldTab.Url("ShiftbookUniversalField");
            this.UniversalFieldTab.AutoSelect = false;
            this.TabController.AddTab(this.UniversalFieldTab);

            this.ShiftbookChecklistTab = new TabPage();
            this.ShiftbookChecklistTab.IsClosable(false);
            this.ShiftbookChecklistTab.Url("ShiftbookChecklist");
            this.ShiftbookChecklistTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookChecklistTab);

            this.TransferDefinitionTab = new TabPage();
            this.TransferDefinitionTab.IsClosable(false);
            this.TransferDefinitionTab.Url("ShiftbookTransferDefinition");
            this.TransferDefinitionTab.AutoSelect = false;
            this.TabController.AddTab(this.TransferDefinitionTab);

            this.ShiftbookShiftPlanModelTab = new TabPage();
            this.ShiftbookShiftPlanModelTab.IsClosable(false);
            this.ShiftbookShiftPlanModelTab.Url("ShiftbookShiftPlanModel");
            this.ShiftbookShiftPlanModelTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookShiftPlanModelTab);
        }
        else if (this.ShiftbookTypeKey() === "InstructionBook") {
            this.ShiftbookRecipientTab = new TabPage();
            this.ShiftbookRecipientTab.IsClosable(false);
            this.ShiftbookRecipientTab.Url("ShiftbookRecipientTab");
            this.ShiftbookRecipientTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookRecipientTab);


            this.ShiftbookChecklistTab = new TabPage();
            this.ShiftbookChecklistTab.IsClosable(false);
            this.ShiftbookChecklistTab.Url("ShiftbookChecklist");
            this.ShiftbookChecklistTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookChecklistTab);
        }
        else if (this.ShiftbookTypeKey() === "TaskBook") {
            this.ShiftbookRecipientTab = new TabPage();
            this.ShiftbookRecipientTab.IsClosable(false);
            this.ShiftbookRecipientTab.Url("ShiftbookRecipientTab");
            this.ShiftbookRecipientTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookRecipientTab);


            this.ShiftbookChecklistTab = new TabPage();
            this.ShiftbookChecklistTab.IsClosable(false);
            this.ShiftbookChecklistTab.Url("ShiftbookChecklist");
            this.ShiftbookChecklistTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookChecklistTab);
        }
        else if (this.ShiftbookTypeKey() === "Briefing") {
            this.ShiftbookRecipientTab = new TabPage();
            this.ShiftbookRecipientTab.IsClosable(false);
            this.ShiftbookRecipientTab.Url("ShiftbookRecipientTab");
            this.ShiftbookRecipientTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookRecipientTab);
        }
        else if (this.ShiftbookTypeKey() === "WorkItemTaskbook") {
            this.ShiftbookRecipientTab = new TabPage();
            this.ShiftbookRecipientTab.IsClosable(false);
            this.ShiftbookRecipientTab.Url("ShiftbookWorkItemTypeTab");
            this.ShiftbookRecipientTab.AutoSelect = false;
            this.TabController.AddTab(this.ShiftbookRecipientTab);
        }
    };
    private GetShiftReportDeepLink() {
        let result = "";
        switch (this.ShiftbookTypeKey()) {
            case "Whiteboard":
                result = '#/WhiteboardBook/' + this.ShiftbookId();
                break;
            case "Briefing":
                result = '#/BriefingBook/';
                break;
            case "InstructionBook":
                result = '#/InstructionBook/' + this.ShiftbookId();
                break;
            case "TaskBook":
                result = '#/TaskBook/' + this.ShiftbookId();
                break;
            default:
                result = '#/Report/ReportByShiftbookId/' + this.ShiftbookId();
                break;
        }
        return result;
    }
    private ChangeIconOnQuickStartModule(): JQueryPromise<void> {
        let result = $.Deferred<void>();
        if (this.IsNew() || this.CssClass() === this.DefaultCssClass()) {
            return result.resolve().promise();
        }
        this.DefaultCssClass(this.CssClass());
        const link = this.GetShiftReportDeepLink();
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: link
        })).then(isActive => isActive ?
            Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
                caption1: this.Name(),
                caption2: this.Name(),
                caption3: this.Name(),
                caption4: this.Name(),
                caption5: this.Name(),
                webUrl: link,
                color: '',
                icon: this.CssClass() ? this.CssClass() : 'fal fa-book',
                sort: 0
            })).then(_ => Bao.raiseEvent('QuickStartModules:refresh', null))
            : result.resolve().promise());
    }


    /*
     * Deletes existing reports from the start date of the pattern change
     * */
    private DeleteExistsNextReports(): JQueryPromise<void> {
        let result = $.Deferred<void>();
        if (this.DeleteNextReports()) {
            return Bao.post("Shiftbook/DeleteExistsNextReportsByShiftbookId", JSON.stringify({
                shiftbookId: this.ShiftbookId()
            }))
                .then((_) => {
                    return result.resolve().promise();
                })
                .always(() => {
                    this.DeleteNextReports(false);
                });
        }
        return result.resolve().promise();
    }
}
export default Shiftbook;